import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import { login, logout, requestResetPassword } from "@/api/auth";
import { errorToast } from "@/components";
import { useSessionStore } from "@/stores";
import { cleanUpUserSession } from "@/utils";

export const useAuth = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const setSession = useSessionStore((s) => {
    return s.setSession;
  });
  const navigate = useNavigate();

  const useLogin = () => {
    return useMutation({
      mutationFn: login,
      onSuccess: ({ data }) => {
        setSession({ token: data.accessToken, type: data.tokenType, expiresIn: data.expiresIn });
        onSuccess?.();
      },
    });
  };

  const useLogout = () => {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: logout,
      onSettled: () => {
        cleanUpUserSession();
        void queryClient.removeQueries();
        navigate({ to: "/" });
      },
    });
  };

  const useRequestResetPassword = () => {
    return useMutation({
      mutationFn: requestResetPassword,
      onError: (err) => {
        errorToast(err);
      },
    });
  };

  return {
    useLogin,
    useLogout,
    useRequestResetPassword,
  };
};
